import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {Item} from "../../../framework/model/core/items/item";
import {Section} from '../../../framework/model/core/sections/section';
import {ActionSheetController, NavController} from "@ionic/angular";
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {OrderService} from "../../services/OrderService";
import {BusinessService} from "../../services/BusinessService";
import {AppDataService} from "../../services/AppDataService";
import {Events} from "../../../framework/providers/events";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";

@Component({
    selector: 'app-section',
    templateUrl: './section.page.html',
    styleUrls: ['./section.page.scss'],
})
export class SectionPage implements OnInit, OnDestroy {

    public sections: Array<Section> = [];
    public section: Section;
    public sectionId: any;
    public models: Array<Item> = [];
    public secmodels: Array<Item> = [];
    public options: object = {};

    public subsOptions: object = {};
    public itemsOptions: object = {};
    public cartToolbarOptions: object = {};

    public filters: object;
    public showItems: boolean = false; //wait until view is ready.
    public initData: boolean = true;
    public ready: boolean = false;

    public imageReady: boolean = true;

    public itemsPrefix: string = 'itemList_' + Math.floor(Math.random() * Math.floor(1000000));
    public advsPrefix: string = 'advSlider_' + +Math.floor(Math.random() * Math.floor(1000000));

    public catalog: boolean;
    public queue: Array<object> = [];

    public sectionsView;

    cart: any;
    sideSectionBarOpen: boolean = false;

    constructor(
        public events: Events,
        public modelTools: ModelToolsProvider,
        public route: ActivatedRoute,
        public businessService: BusinessService,
        public appDataService: AppDataService,
        public actionSheetController: ActionSheetController,
        public orderService: OrderService,
        public modelProvider: ModelProvider) {

        this.catalog = this.businessService.isCatalog();

        this.sectionId = this.route.snapshot.paramMap.get("id");
        this.route.queryParams.subscribe(params => {
            if (this.filters) return;
            if (params['filters']) {
                this.filters = JSON.parse(JSON.stringify(params['filters']));
            }

            if (!this.filters) this.filters = {};
            this.filters['sectionId'] = this.sectionId;
            if (params['disableInitData'])
                this.initData = false;

            // } else {
            this.section = params['model'];

            console.log(this.section, this.sectionId)


            if (!this.section || !this.section.data) {
                this.listSection();
            }

            //
            // if (!this.sectionId)
            //     this.sectionId = this.section.data.id;
        });


        this.events.subscribe('sectionClicked', (params) => {
            // this.section.data.images = [];
            // this.imageReady = false;
            let me = this;
            setTimeout(function () {
                me.setSection(params);
            })
        });

        this.events.subscribe('backQueue', (params) => {
            this.backQueue();
        });

        // this.sectionsView = 'scroll';
        this.sectionsView = this.businessService.screenSize[0] > 1000 ? 'cards' : 'scroll';

        //sectionPage_sideSectionBarOpen is open?
        if (this.orderService.sectionPage_sideSectionBarOpen) {
            this.sideSectionBarOpen = true;
        }
    }

    ngOnInit() {
        this.cart = this.orderService.getCart();
        this.addToQueue();

        let me = this;
        me.ready = true;

    }

    addToQueue() {
        this.queue.push({'sectionId': this.sectionId, 'model': this.section});
    }

    backQueue() {
        this.queue.splice(-1, 1);
        this.setSection(this.queue[this.queue.length - 1], true);
        //console.logthis.queue)
    }

    listSection() {
        let models = this.appDataService.getSections([this.sectionId]);

        if (!models.length) return;

        this.section = models[0];


        // this.modelProvider.list('section', {'id': this.sectionId}).then((res) => {
        //     this.section = res['models'][0];
        //     this.showItems = true;
        // })
    }

    setSection(params, skipQueue = false) {
        //console.logparams)
        this.section = this.orderService.copy(params['model']);
        this.sectionId = this.section.data.id;
        this.filters['sectionId'] = this.sectionId;
        this.filters['src'] = this.section.data.images[0];
        // //console.logthis.filters)
        this.events.publish(this.itemsPrefix + '_updateItemsFilter', this.filters);
        this.events.publish(this.itemsPrefix + '_updateSectionsFilter', this.filters);
        this.events.publish(this.advsPrefix + '_updateFilter', this.filters);

        if (!skipQueue)
            this.addToQueue()


        // return
        //
        // this.showItems = false;
        // let me = this;
        // // this.section = null;
        // setTimeout(function () {
        //     me.showItems = true;
        //     me.filters['sectionId'] = section.data.id;
        //     me.sectionId = section.data.id;
        //     me.listSection();
        // });
        // me.section = section;
        // });


    }

    // ionViewDidLoad() {console.log("ionViewDidLoad")}
    // ionViewWillEnter() {console.log("ionViewWillEnter")}
    // ionViewDidEnter() {console.log("ionViewDidEnter")}
    // ionViewWillLeave() {console.log("ionViewWillLeave")}
    // ionViewDidLeave() {console.log("ionViewDidLeave")}
    // ionViewWillUnload() {console.log("ionViewWillUnload")}

    ngAfterViewInit() {
        let me = this;
        // setTimeout(function () {
        me.showItems = true;
        // })
    }

    ngOnDestroy() {
        this.events.unsubscribe('sectionClicked');
        this.events.unsubscribe('backQueue');
    }

    onscroll(on) {
        this.events.publish('onscroll_innerpage', {on: on});
    }

    async viewStaffSettings(model) {
        let buttons = this.orderService.viewStaffSettings(false, null, model, 'section');
        const actionSheet = await this.actionSheetController.create({
            header: this.modelTools.getTranslate('sectionSettings'),
            cssClass: 'my-custom-class',
            buttons: buttons
        });
        await actionSheet.present();

        const {role, data} = await actionSheet.onDidDismiss();
        console.log('onDidDismiss resolved with role and data', role, data);
    }

    setSideSectionBarStatus(status) {
        this.sideSectionBarOpen = status;
        this.orderService.sectionPage_sideSectionBarOpen = status;
    }

}
